import { BrowserRouter, Routes, Route } from 'react-router-dom';

import VerifyPage from './pages/VerifyPage';
import SuccessPage from './pages/SuccessPage';
import FailedPage from './pages/FailedPage';

function App() {

  return (
    <BrowserRouter>

      <Routes>

        <Route
          path="/verify/:token"
          element={<VerifyPage />}
        />

        <Route
          path="/success"
          element={<SuccessPage />}
        />

        <Route
          path="/failed"
          element={<FailedPage />}
        />

      </Routes>

    </BrowserRouter>
  );
}

export default App;